import css from 'styled-jsx/css';
import { common } from '../../../theme/theme';

const style = css`
  .admin-modal {
    width: 380px;
    padding: 16px;
  }
  .label {
    font-size: 14px;
    margin-bottom: 6px;
  }
  .admin-delete-title {
    font-size: 16px;
    font-weight: 500;
    font-family: Arial, Helvetica, sans-serif;
    color: black;
    margin-top: 16px;
  }
  .admin-modal-inputs {
    width: 100%;
    padding-bottom: 16px;
  }
  .admin-wrapper,
  .reason-selector-wrapper {
    margin-bottom: 8px;
  }
  .admin-modal :global(.submit-button) {
    margin-top: 24px;
    ${common.button}
    ${common.submitButton}
    background-color: red;
  }
  .admin-modal :global(.submit-button:hover) {
    margin-top: 24px;
    ${common.button}
    ${common.submitButton}
    background-color: red;
  }
  .admin-modal :global(.cancel-button) {
    ${common.button}
    ${common.cancelButton}
  }
  .admin-modal :global(.cancel-button:hover) {
    ${common.button}
    ${common.cancelButton}
  }
`;

export default style;
